// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__BIkN7","main_collection":"styles_main_collection__ARofP","bottom":"styles_bottom__MdOlt"};